@if (uploadManager.hasExpanded()) {
    <div class="upload-shade position-fixed top-0 start-0 w-100 h-100 bg-black"></div>
}

@if (uploadManager.expandedCard(); as expanded) {
    <div class="upload-expanded-wrap position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
        <app-upload-card
            [card]="expanded"
            [expanded]="true"
            (minimize)="uploadManager.minimize($event)"
            (maximize)="uploadManager.maximize($event)"
            (closeCard)="uploadManager.close($event)"
        ></app-upload-card>
    </div>
}

<div class="upload-dock position-fixed bottom-0 end-0 d-flex flex-column-reverse gap-3 p-3">
    @for (card of uploadManager.minimizedCards(); track card.id) {
        <app-upload-card
            [card]="card"
            [expanded]="false"
            (minimize)="uploadManager.minimize($event)"
            (maximize)="uploadManager.maximize($event)"
            (closeCard)="uploadManager.close($event)"
        ></app-upload-card>
    }
</div>
